import React, {Component} from 'react';
import {Button, Form, Table, Container, Row, Col, ButtonToolbar, Overlay, Popover} from 'react-bootstrap';


export default class ProductDetail extends Component {
    render() {
        return (
            <div style={{margin: 10, flex: 0.8}} >
                <div class="container">
                    1.한명으로 구성된 영상<br />
                        [사진갯수]_[아티스트명].jpg<br />
                        1_YERIN.jpg<br />
                        1_SOWON.jpg<br />
                    <p />
                        2.두명으로 구성된 영상<br />
                        [UNIT갯수]_[아티스트명1_아티스트명2_….].jpg<br />
                        (카드위치는 아티스트명의 순서와 같습니다.)<br />
                        2_UINT_SOWON_YERIN.jpg<br />
                    <p />
                        3.여섯명으로 구성된 영상<br />
                        3배 너비의 2줄 사진으로 구성된 UNIT<br />
                        3_UNIT_SYY-SUY.jpg<br />
                        (- 기호가 줄바꿈 기호)<br />
                    <p />
                        * 필수<br />
                        인식에만 사용되는 이미지  전체의 1/2<br />
                        0_SYY.jpg<br />
                        0_SUY.jpg<br />
                    <p />
                        인식에만 사용되는 영상<br />
                        0_SYY.mp4<br />
                        0_SUY.mp4<br />
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// src/components/DRMExplanation.js